import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import {ActivatedRoute} from "@angular/router";
import {RequestService} from "../../core/services/request/request.service";
import {LegacyNavigateService} from "../../core/services/legacy-navigate/legacy-navigate.service";
import {AuditHistoryService} from "../../core/services/audit-history/audit-history.service";
import {AuditHistoryGroupModel} from "../../core/services/audit-history/audit-history-group.model";
import {AuditHistoryModel} from "../../core/services/audit-history/audit-history.model";
import {AuditHistoryHeaderModel} from "../../core/services/audit-history/audit-history-header.model";
import {InternationalizationService} from "../../core/services/internationalization/internationalization.service";
import {escape} from "lodash";
import {$translate} from "../../core/services/internationalization/localize.service";

@Component({
  selector: 'sb-audit-page',
  templateUrl: './audit-page.component.html',
  styleUrls: ['./audit-page.component.scss'],
})
export class AuditPageComponent implements OnInit, OnDestroy {
  title = "";

  noRecords: boolean = false;
  noFilteredRecords: boolean = false;

  groupedRecords: AuditHistoryGroupModel[];
  headerRecord: AuditHistoryHeaderModel;

  activatedRouteSubscription: Subscription | null;

  constructor(private activatedRoute: ActivatedRoute,
              private requestService: RequestService,
              private legacyNavigateService: LegacyNavigateService,
              private legacyI18nService: InternationalizationService,
              private auditHistoryService: AuditHistoryService) {

  }

  async ngOnInit() {
    // Wipe out the page context
    (window as any).KO_PAGE_CONTEXT.clear();

    // Wipe out the Knockout content.
    const pageContentMain = document.getElementById("page-content-main");
    if (pageContentMain) {
      pageContentMain.innerHTML = "";
    }
    const errorConsole = document.getElementById("error-console");
    if (errorConsole) {
      errorConsole.innerHTML = "";
    }

    // Mark as portal page
    document.getElementById("detailMain")?.classList?.add("sb-portal-page-content");

    // Find the record to display.
    this.activatedRouteSubscription = this.activatedRoute.paramMap.subscribe(async params => {
      let tableName = params.get("tableName");
      let recordId = params.get("id");

      const noopFilter: (AuditHistoryModel) => boolean = (record: AuditHistoryModel) => true;

      // TODO: how do we determine the journal fields of the record
      const groupedAndFilteredRecords = await this.auditHistoryService.getGroupedAuditRecords(tableName, recordId, [], noopFilter);
      this.groupedRecords = groupedAndFilteredRecords.groups;
      this.noRecords = groupedAndFilteredRecords.recordCount === 0;
      this.noFilteredRecords = groupedAndFilteredRecords.filteredRecordCount === 0;
      this.title = $translate("audithistory.title")`Audit history for <i>${recordId}</i>`;

      if (!this.noFilteredRecords) {
        this.headerRecord = groupedAndFilteredRecords.header;

        this.title = $translate("audithistory.title")`Audit history for <i>${escape(this?.headerRecord?.RelatedRecord?.displayValue)}</i>`;
      }
    });
  }

  ngOnDestroy(): void {
    this.activatedRouteSubscription && this.activatedRouteSubscription.unsubscribe();
  }

  // Fake button navigation

  buttonLabel(key: string): string {
    return this.legacyI18nService.getMessage(key);
  }

  canGoBack() {
    return this.legacyNavigateService.canGoBack();
  }

  back() {
    this.legacyNavigateService.back();
  }

}
